<template>
  <Modal @close="closeModal()" :closeIcon="true" size="md" :withoutFooter="true">
      <div slot="body">
          <PriceTable />
      </div>
  </Modal>
</template>

<script>
import Modal from '@/components/common/Modal'
import PriceTable from '@/components/order/OrderPriceTable'

export default {
    name: 'LicenseChangeModal',
    components: {
        Modal,
        PriceTable
    },
    
    created() {
        this.$root.$on('closeLicenseModal', this.closeModal);
    },
    beforeDestroy() {
        this.$root.$off('closeLicenseModal', this.closeModal);
    },

    methods: {
        closeModal() {
            this.$emit('close');
        }
    }
}
</script>